import paths from "~/constants/paths";

export default defineNuxtRouteMiddleware((to) => {
  const userToken = useCookie("hs-token");

  const protectedPages = {
    [paths.account.index]: true,
    [paths.account.details]: true,
    [paths.account.addresses]: true,
    [paths.account.addressForm]: true,
    [paths.account.changePassword]: true,
    [paths.account.paymentDetails]: true,
    [paths.account.orders.active]: true,
    [paths.account.orders.inactive]: true,
    [paths.account.orders.details]: true,
    [paths.wishList]: true,
    [paths.checkout]: true,
    [paths.orderPlaced]: true,
    [paths.paymentFailed]: true,
    [paths.saved_cart]: true,
    [paths.paymentDetails]: true,
  };

  if (protectedPages[to.path] && !userToken.value) {
    return navigateTo({
      path: paths.login,
      state: {
        back: to.path,
      },
    });
  }

  // Protect dynamic pages /cart/[id] not /cart
  if (!userToken.value && to.path.startsWith("/cart/") && to.path !== "/cart") {
    return navigateTo({
      path: paths.login,
      state: {
        back: to.path,
      },
    });
  }

  if (
    (to.path === paths.login || to.path === paths.register) &&
    userToken.value
  ) {
    return navigateTo(paths.home);
  }
});
